declare const Cookiebot: any

import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

export default defineNuxtPlugin(() => {
  interface IConsent {
    marketing: boolean
    method: string
    necessary: boolean
    preferences: boolean
    stamp: string
    statistics: boolean
  }

  const GDPR_COOKIES = {
    FNC: 'fnc',
    STS: 'sts',
    ADV: 'adv',
    WEB: 'web'
  }

  const isInsiderScriptLoaded = ref(false)

  const gdprCookies = useCookie<string>('gdpr_settings', COOKIE_OPTIONS)

  window?.addEventListener(
    'CookiebotOnAccept',
    function () {
      setSelectedGDPRCookies(Cookiebot?.consent)
      useFetchGeolocate()

      if (Cookiebot?.consent.preferences) {
        loadInsiderScript()
      } else {
        unloadInsiderScript()
      }
    },
    false
  )

  window?.addEventListener(
    'CookiebotOnDecline',
    function () {
      setSelectedGDPRCookies(Cookiebot?.consent)
      useFetchGeolocate()

      if (!Cookiebot?.consent.preferences) {
        unloadInsiderScript()
      }
    },
    false
  )

  const { load, unload } = useScriptTag(
    '//airbaltic.api.useinsider.com/ins.js?id=10001191',
    () => {
      isInsiderScriptLoaded.value = true
    },
    {
      manual: true
    }
  )

  const loadInsiderScript = () => {
    if (!isInsiderScriptLoaded.value) {
      load()
    }
  }

  const unloadInsiderScript = () => {
    if (isInsiderScriptLoaded.value) {
      unload()
      isInsiderScriptLoaded.value = false
    }
  }

  const setSelectedGDPRCookies = (consent: IConsent) => {
    const selectedCookies = [GDPR_COOKIES.FNC]

    if (consent.statistics) {
      selectedCookies.push(GDPR_COOKIES.STS)
    }

    if (consent.marketing) {
      selectedCookies.push(GDPR_COOKIES.ADV)
    }

    if (consent.preferences) {
      selectedCookies.push(GDPR_COOKIES.WEB)
    }

    gdprCookies.value = selectedCookies.join(',')
  }
})
